import React, { useState, useEffect } from "react";
import axios from "axios";
import MeetUpEventNave from "./MeetUpEventNave";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import AllModuleData from "../../../../Reuseable/AllModuleData";

const AdminMeetupDashboard = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState([]);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/admin/meetup_event/live`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);
  return (
    <>
      <div className="AS">
        <MeetUpEventNave />

        <div className="card card-bg head-line mb-2 mt-5">
          <div className="text-light d-flex justify-content-center p-2">
            <div className="faTrophy">
              <i className="fas fa-trophy"></i>
            </div>
            <h4 className="mx-3 text-white p-2">
              <span className="livechat-card-small">Meetup Live Now</span>
            </h4>
          </div>
        </div>
        {buffer ? (
          <LoaderPost />
        ) : (
          <AllModuleData
            data={event_data}
            urlLink={`/superstar-admin/meetup-events/pending`}
          />
        )}
      </div>
    </>
  );
};

export default AdminMeetupDashboard;
